<template>
  <div class="timeCode" :class="expanded ? 'expanded' : ''" v-if="startTime && currentTime" @click="toggleExpand">
    {{ timestamp }}
  </div>
</template>

<script>
export default {
  data: () => ({
    startTime: null,
    currentTime: null,
    expanded: false
  }),
  created() {
    this.startTime = new Date()
    requestAnimationFrame(this.updateTime)
  },
  destroyed() {
    cancelAnimationFrame(this.updateTime)
  },
  methods: {
    updateTime() {
      this.currentTime = new Date()
      requestAnimationFrame(this.updateTime)
    },
    toggleExpand() {
      this.expanded = !this.expanded
    }
  },
  computed: {
    timestamp() {
      return new Date(this.currentTime - this.startTime).toISOString().slice(12,22)
    }
  }
}
</script>
